<div *ngIf="!profileState?.result" class="modal-wrapper" [dir]="rtl ? 'rtl' : 'ltr'">
  <div data-tid="cmx-createoneclickprofile-btnexit" (click)="cancel()" class="close-btn custom-dialog-container__close">
    <span class="cmx-icon-close"></span>
  </div>
  <ng-container *ngIf="!isEditMode; else editProfile">
    <h4 [attr.data-tid]="'cmx-createprofile-lblmaintitle'">
      {{ 'views.one_click.create_profile' | translate }}
      {{ preSelectedBusinessLine ? ' - ' + preSelectedBusinessLine.productLineDesc : '' }}
    </h4>
    <p data-tid="cmx-createprofile-lblsubtitle" class="sub-title mb-4">
      {{ 'views.one_click.create_profile_description' | translate }}
    </p>
  </ng-container>

  <ng-template #editProfile>
    <h4>
      {{ 'views.one_click.edit_profile' | translate }}
    </h4>
  </ng-template>

  <div class="separator"></div>
  <div [ngClass]="{ 'edit-view': isEditMode }">
    <div class="section" *ngIf="businessLines?.length > 1 && !isEditMode && !preSelectedBusinessLine">
      <div class="sub-title" data-tid="cmx-createoneclickprofile-lblbusinesslinesinstructions">
        {{ 'views.one_click.select_business_lines' | translate }}
      </div>
      <cwc-radio-group value="businessLines[0]?.productLineCode" name="'business-lines'" designVersion="v2">
        <ng-container *ngFor="let businessLine of businessLines">
          <cwc-radio
            class="radio"
            [attr.data-tid]="'cmx-createoneclickprofile-rdbbtn' + businessLine?.productLineCode"
            (cwcClick)="selectBusinessLine(businessLine)"
            [value]="businessLine.productLineCode"
            [checked]="businessLines[0]?.productLineCode === businessLine.productLineCode"
            designVersion="v2"
          >
            {{ businessLine.productLineDesc | translate | titlecase }}
          </cwc-radio>
        </ng-container>
      </cwc-radio-group>
    </div>

    <div class="section" *ngIf="shippingMethods?.length > 1 && !isEditMode">
      <div class="sub-title" data-tid="cmx-createoneclickprofile-lbldeliverymethodinstructions">
        {{ 'views.one_click.select_delivery_method' | translate }}
      </div>
      <cwc-radio-group value="shippingMethods[0]?.shippingConditionCode" name="'delivery-method'" designVersion="v2">
        <ng-container *ngFor="let shippingCondition of shippingMethods">
          <cwc-radio
            class="radio"
            [attr.data-tid]="'cmx-createoneclickprofile-rdbbtn' + shippingCondition?.shippingConditionCode"
            (cwcClick)="selectShippingMethod(shippingCondition)"
            [value]="shippingCondition.shippingConditionCode"
            [checked]="shippingMethods[0]?.shippingConditionCode === shippingCondition.shippingConditionCode"
            designVersion="v2"
          >
            {{ shippingCondition.shippingConditionDesc | translate | titlecase }}
          </cwc-radio>
        </ng-container>
      </cwc-radio-group>
    </div>

    <div class="section" [ngClass]="{ 'not-visible': shippingLocationModes?.length <= 1 }" *ngIf="!isEditMode">
      <div class="sub-title" [attr.data-tid]="'cmx-createoneclickprofile-lblorderprofileinstructions'">
        {{ 'views.one_click.create_profile_for' | translate }}
      </div>
      <cwc-radio-group value="selectedShippingMode?.code" name="'shipment-location'" designVersion="v2">
        <ng-container *ngFor="let shippingLocationMode of shippingLocationModes">
          <cwc-radio
            class="radio"
            [attr.data-tid]="'cmx-createoneclickprofile-rdbbtn' + shippingLocationMode?.code"
            [value]="shippingLocationMode.code"
            (cwcClick)="selectShippingLocationMode(shippingLocationMode)"
            [checked]="selectedShippingMode?.code === shippingLocationMode.code"
            [attr.is-checked]="selectedShippingMode?.code === shippingLocationMode.code"
            designVersion="v2"
          >
            {{ shippingLocationMode.desc | translate | titlecase }}
          </cwc-radio>
        </ng-container>
      </cwc-radio-group>
    </div>
  </div>

  <template #builder></template>

  <!-- Actions -->
  <div *ngIf="!isEditMode && canAddNewProduct" class="sub-actions">
    <cwc-button data-tid="cmx-createoneclickprofile-btnadd" [variant]="'support'" (cwcClick)="addItem()">
      {{ 'views.specifications.add_product' | translate }}
    </cwc-button>
    <cwc-button
      class="action-button"
      data-tid="cmx-createoneclickprofile-btnadd"
      [disabled]="componentRenders.length <= 1"
      [variant]="'support'"
      [attr.data-test]="orderFieldTestIds?.REMOVE_PRODUCT_BUTTON"
      (cwcClick)="removeItem()"
      designVersion="v2"
    >
      {{ 'views.specifications.remove_product' | translate }}
    </cwc-button>
  </div>
  <div class="actions">
    <cwc-button
      class="action-button"
      data-tid="cmx-createoneclickprofile-btncancel"
      [variant]="'support'"
      [attr.data-test]="orderFieldTestIds?.CANCEL_BUTTON"
      (cwcClick)="cancel()"
      designVersion="v2"
    > 
      {{ 'views.common.cancel' | translate }}
    </cwc-button>
    <cwc-button
      class="action-button"
      data-tid="cmx-createoneclickprofile-btncreate"
      (cwcClick)="createProfile()"
      [attr.data-test]="orderFieldTestIds?.CREATE_PROFILE_BUTTON"
      [disabled]="profileState?.loading || !isFormDataValidIndicator"
      designVersion="v2"
    >
      <ng-container *ngIf="profileState?.loading">
        {{ 'views.one_click.creating_profile' | translate }}...
      </ng-container>
      <ng-container *ngIf="!profileState?.loading">
        <ng-container *ngIf="!preloadedOrder">{{ 'views.common.create' | translate }}</ng-container>
        <ng-container *ngIf="preloadedOrder">{{ 'views.global.btn_save' | translate }}</ng-container>
      </ng-container>
    </cwc-button>
  </div>
</div>

<div>
  <ng-container *ngIf="profileState?.result">
    <div
      data-tid="cmx-oneclickprofilecreatedresult-btnclose"
      (click)="cancel()"
      class="close-btn custom-dialog-container__close"
    >
      <span class="cmx-icon-close"></span>
    </div>

    <!-- Result modal -->
    <div class="container-fluid">
      <div class="container-layout center-text">
        <ng-container>
          <div>
            <span
              data-tid="cmx-oneclickprofilecreatedresult-resulticon"
              [ngClass]="{
                'cmx-icon-check-rounded-active-fill': profileState.result['success'],
                'cmx-icon-warning-rounded-fill': !profileState.result['success']
              }"
              aria-hidden="true"
            ></span>
            <div data-tid="cmx-oneclickprofilecreatedresult-lblresultmessage" class="message-text" *ngIf="isEditMode">
              {{ 'views.one_click.profile_edited' | translate }}
              <hr />
            </div>
            <div data-tid="cmx-oneclickprofilecreatedresult-lblresultmessage" class="message-text" *ngIf="!isEditMode">
              {{ 'views.one_click.profile_created' | translate }}
              <hr />
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="actions">
      <cwc-button
        data-tid="cmx-oneclickprofilecreatedresult-btnoneclickprofiles"
        *ngIf="!profileState?.loading"
        (cwcClick)="goToOneClickProfiles()"
        [attr.data-test]="orderFieldTestIds?.SUPPORT_BUTTON"
        [variant]="'support'"
        designVersion="v2"
      >
        {{ 'views.one_click.go_to_profiles' | translate }}
      </cwc-button>
    </div>
  </ng-container>
</div>
